@if (showTypeSelection) {
<p-dialog [modal]="true" [visible]="true" [closable]="false" [draggable]="false" [resizable]="false"
    [style]="{ width: '800px'}" (onHide)="close$.emit()" [baseZIndex]="1100"
    class="neo-dialog invite-candidate-dialog invite-candidate-type-selection">
    <div class="dialog-wrapper">
        <!-- Header -->
        <div class="dialog-header">
            <h2 class="dialog-title">Invite Candidate</h2>
            <div class="header-right">
                <button type="button" class="dialog-close-btn" (click)="close$.emit()" aria-label="Close">
                    <em class="pi pi-times"></em>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="dialog-content">
            <div class="content-wrapper type-selection-container neo-grid" [class.neo-grid-cols-2]="from() === 'events'"
                [class.neo-grid-cols-3]="from() !== 'events'">
                @if (from() !== "events") {
                <p-card>
                    <div class="type-selection-card" [class.active]="type === 'single'" tabindex="0"
                        (click)="changeActiveType('single')">
                        <div class="type-selection-icon">
                            <i class="pi pi-user-plus"></i>
                        </div>

                        <div class="type-selection-content">
                            <div class="type-selection-title">
                                Single - Invite
                            </div>

                            <div class="type-selection-subtitle">
                                Invite one candidate by entering their details manually.
                            </div>
                        </div>
                    </div>
                </p-card>
                }

                <p-card>
                    <div class="type-selection-card" [class.active]="type === 'bulk-invite'" tabindex="0"
                        (click)="changeActiveType('bulk-invite')">
                        <div class="type-selection-icon">
                            <i class="pi pi-users"></i>
                        </div>

                        <div class="type-selection-content">
                            <div class="type-selection-title">
                                Bulk - Invite
                            </div>

                            <div class="type-selection-subtitle">
                                Send invitations to multiple candidates at once using a excel.
                            </div>
                        </div>
                    </div>
                </p-card>

                <p-card>
                    <div class="type-selection-card" [class.active]="type === 'bulk-registration'" tabindex="0"
                        (click)="changeActiveType('bulk-registration')">
                        <div class="type-selection-icon">
                            <i class="pi pi-file-import"></i>
                        </div>

                        <div class="type-selection-content">
                            <div class="type-selection-title">
                                Bulk - Registration
                            </div>

                            <div class="type-selection-subtitle">
                                Upload a file to register multiple candidates in one go.
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>

        <!-- Footer -->
        <div class="dialog-footer" style="justify-content: end;">
            <button pButton pRipple type="button" label="Next" class="change-invite-type-btn"
                (click)="toggleTypeSelection()"></button>
        </div>
    </div>
</p-dialog>
}

@if (!showTypeSelection && inviteForm) {
<p-dialog [modal]="true" [(visible)]="showForm" (onHide)="close$.emit()" [showHeader]="true" [closable]="true"
    [header]="type === 'bulk-registration' ? 'Register Candidate' : 'Invite Candidate'" [draggable]="false"
    [resizable]="false" [style]="{ width: '800px', 'max-height': '80vh'}" [baseZIndex]="1100"
    class="neo-dialog invite-candidate-dialog">
    <div class="dialog-wrapper">
        <div class="dialog-content neo-grid neo-grid-cols-1" [formGroup]="inviteForm">
            @if (type === "bulk-registration") {
            <ng-container *ngTemplateOutlet="templateDetails"></ng-container>

            <div class="template-section neo-input-wrapper">
                <label>Download Sample Template</label>
                <div class="template-download-container">
                    <div class="template-file-info">
                        <div class="file-icon">
                            <em class="pi pi-file-excel"></em>
                        </div>
                        <div class="file-details">
                            <div class="file-name">Sample Bulk Registration Candidate.XLSX</div>
                            <p class="upload-registration-note text-sm text-warning font-medium flex items-start gap-1.5">
                                <span class="inline-block w-1 h-1 rounded-full bg-warning mt-2 flex-shrink-0"></span>
                                This template is event-specific. Use it only to bulk register candidates for {{from() === "events" ? "this" : "the selected"}} event.
                            </p>
                        </div>
                    </div>
                    <button type="button" class="download-btn" (click)="sampleBulkRegistration()">
                        Download
                    </button>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="uploadFileSection"></ng-container>
            }

            @if (type === "bulk-invite") {
            <ng-container *ngTemplateOutlet="templateDetails"></ng-container>

            <div class="template-section neo-input-wrapper">
                <label>Download Sample Template</label>
                <div class="template-download-container">
                    <div class="template-file-info">
                        <div class="file-icon">
                            <em class="pi pi-file-excel"></em>
                        </div>
                        <div class="file-details">
                            <div class="file-name">Sample Bulk Invite Candidate.XLSX</div>
                        </div>
                    </div>
                    <button type="button" class="download-btn" (click)="sampleBulkInvite()">
                        Download
                    </button>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="uploadFileSection"></ng-container>
            }

            @if (type === "single") {
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label>First Name</label>
                    <input bigger type="text" pInputText formControlName="firstName" placeholder="Candidate first name">
                    <app-handle-error
                        [clicked]="inviteForm.get('firstName')?.touched! || inviteForm.get('firstName')?.dirty!"
                        [control]="inviteForm.get('firstName')" name="First Name">
                    </app-handle-error>
                </div>

                <div class="neo-input-wrapper">
                    <label>Last Name</label>
                    <input bigger type="text" pInputText formControlName="lastName" placeholder="Candidate last name">
                    <app-handle-error
                        [clicked]="inviteForm.get('lastName')?.touched! || inviteForm.get('lastName')?.dirty!"
                        [control]="inviteForm.get('lastName')" name="Last Name">
                    </app-handle-error>
                </div>
            </div>

            <div class="neo-input-wrapper">
                <label required>Email Address</label>
                <input bigger type="text" pInputText formControlName="email" placeholder="Candidate email">
                <app-handle-error [showSampleValues]="true" sampleValue="example@example.com"
                    [clicked]="inviteForm.get('email')?.touched! || inviteForm.get('email')?.dirty!"
                    [control]="inviteForm.get('email')" name="Email">
                </app-handle-error>
            </div>

            <div class="neo-input-wrapper">
                <label>Gender</label>
                <p-select bigger appendTo="body" class="form-dropdown" optionLabel="label" formControlName="gender"
                    [options]="genderList" placeholder="Choose a gender">
                </p-select>
                <app-handle-error [clicked]="inviteForm.get('gender')?.touched! || inviteForm.get('gender')?.dirty!"
                    [control]="inviteForm.get('gender')" name="Gender">
                </app-handle-error>
            </div>

            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label>Date of Birth</label>
                    <p-datepicker bigger iconDisplay="input" formControlName="date_of_birth" dateFormat="mm-dd-yy"
                        dataType="date" [maxDate]="currentDate" [showIcon]="true" [showTime]="false"
                        placeholder="Select a date" appendTo="body" [panelStyleClass]="'filter-date-range'">
                    </p-datepicker>
                    <app-handle-error
                        [clicked]="inviteForm.get('date_of_birth')?.touched! || inviteForm.get('date_of_birth')?.dirty!"
                        [control]="inviteForm.get('date_of_birth')" name="Age">
                    </app-handle-error>
                </div>

                <div class="neo-input-wrapper">
                    <label>Mobile Number</label>
                    <input bigger placeholder="Candidate mobile number" type="text" pInputText
                        formControlName="mobileNumber" class="form-input" (keypress)="restrictNumber($event)"
                        autocomplete="off">
                    <app-handle-error [showSampleValues]="true" sampleValue="9876543210"
                        [clicked]="inviteForm.get('mobileNumber')?.touched! || inviteForm.get('mobileNumber')?.dirty!"
                        [control]="inviteForm.get('mobileNumber')" name="Mobile">
                    </app-handle-error>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="templateDetails"></ng-container>

            <div class="neo-input-wrapper">
                <label required>Source Name</label>
                <p-select bigger class="form-dropdown source-dropdown" optionLabel="label" optionValue="value"
                    formControlName="sourceName" [options]="sourceNameList" placeholder="Choose a source name"
                    #sourceName [panelStyle]="{
                                'min-width': sourceName.el.nativeElement.offsetWidth + 'px',
                                'max-width': sourceName.el.nativeElement.offsetWidth + 'px'
                            }" appendTo="body">
                </p-select>
                <app-handle-error
                    [clicked]="inviteForm.get('sourceName')?.touched! || inviteForm.get('sourceName')?.dirty!"
                    [control]="inviteForm.get('sourceName')" name="Source Name">
                </app-handle-error>
            </div>
            }
        </div>
    </div>
    <!-- Footer -->
    <div class="dialog-footer">
        <button pButton pRipple [outlined]="true" severity="secondary" class="change-invite-type-btn"
            (click)="toggleTypeSelection()">
            <em class="pi pi-arrow-left" style="margin-right: 8px;"></em>
            Back
        </button>
        <button pButton pRipple [label]="type === 'bulk-registration' ? 'Register' : 'Send Invite'"
            (click)="inviteCandidate()" [disabled]="disableInvite || sendingInvite" [loading]="sendingInvite"></button>
    </div>
</p-dialog>
}

<ng-template #templateDetails [formGroup]="inviteForm">
    @if (!eventId) {
    <div class="neo-input-wrapper">
        <label required>Event Category</label>
        <p-select bigger class="form-dropdown" optionLabel="label" optionValue="value" formControlName="eventCategory"
            [options]="eventCategories" (onChange)="getAllEvents($event)" placeholder="Choose an event category"
            #eventCategory [panelStyle]="{
                            'min-width': eventCategory.el.nativeElement.offsetWidth + 'px',
                            'max-width': eventCategory.el.nativeElement.offsetWidth + 'px'
                        }" appendTo="body">
        </p-select>
        <app-handle-error
            [clicked]="inviteForm.get('eventCategory')?.touched! || inviteForm.get('eventCategory')?.dirty!"
            [control]="inviteForm.get('eventCategory')" name="Event Category">
        </app-handle-error>
    </div>

    <div class="neo-input-wrapper">
        <label required>Event Name</label>
        <p-select bigger class="form-dropdown event-name-dropdown" optionLabel="label" optionValue="value"
            formControlName="eventId" [options]="eventList" [filter]="true" filterBy="label"
            (onChange)="eventChange($event)" (onFilter)="onEventDropdownFilter($event)"
            (onShow)="onEventDropdownShow($event)" (onHide)="onEventDropdownHide($event)"
            [loading]="isLoadingMoreEvents" [emptyMessage]="loadEventList ? 'Loading events...' : 'No events found'"
            placeholder="Choose an event name" #eventName [panelStyle]="{
                            'min-width': eventName.el.nativeElement.offsetWidth + 'px',
                            'max-width': eventName.el.nativeElement.offsetWidth + 'px'
                        }" appendTo="body">
        </p-select>
        <app-handle-error [clicked]="inviteForm.get('eventId')?.touched! || inviteForm.get('eventId')?.dirty!"
            [control]="inviteForm.get('eventId')" name="Event Name">
        </app-handle-error>
    </div>
    }
</ng-template>

<ng-template #uploadFileSection>
    <div class="upload-section neo-input-wrapper">
        <label class="field-label" required>Upload File</label>
        <div class="upload-container">
            <div *ngIf="!cohortUploaded" class="upload-dropzone" ngx-dropzone
                [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
                [multiple]="false" (change)="cohortUpload($event)">
                <ngx-dropzone-label *ngIf="!uploadingFile" class="dropzone-content">
                    <div class="upload-icon">
                        <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                    </div>
                    <div class="upload-text">
                        Drag & Drop your files here or <span class="upload-link">Choose Files</span>
                    </div>
                    <div class="upload-format">Recommended .XLSX</div>
                </ngx-dropzone-label>
                <div *ngIf="uploadingFile" class="upload-loading">
                    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7"
                        animationDuration="0.5s">
                    </p-progressSpinner>
                </div>
            </div>

            <div *ngIf="cohortUploaded" class="uploaded-file-container">
                <div class="uploaded-file-info">
                    <div class="file-icon">
                        <em class="pi pi-file"></em>
                    </div>
                    <div class="file-details">
                        <div class="file-name">{{ fileUploadPayload?.file_name }}</div>
                        <div class="file-size">{{ cohortFileSize }}</div>
                    </div>
                    <button type="button" class="remove-file-btn" (click)="onRemoveExcel()">
                        <em class="pi pi-times"></em>
                    </button>
                </div>
            </div>
        </div>
        <p class="upload-note"> Maximum invite up to {{ bulkInviteLimit | number }} candidates.</p>
    </div>
</ng-template>